import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import SlideBannerBlock from '../../components/SlideBannerBlock/SlideBannerBlock';
import Search from '../../components/Search/Search';
import api from '../../services/api';
import { getMediaUrl } from '../../services/media';
import styles from './Home.module.css';

const Home = () => {
  const { t } = useLanguage();
  const [randomBooks, setRandomBooks] = useState([]);
  // const [featuredPersons, setFeaturedPersons] = useState([]);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/books').then((res) => {
      const data = res.data?.books || res.data?.content || (Array.isArray(res.data) ? res.data : []);
      const shuffled = [...data].sort(() => Math.random() - 0.5);
      setRandomBooks(shuffled.slice(0, 24));
    }).catch(() => setRandomBooks([]));
  }, []);

  // useEffect(() => {
  //   api.get('/persons').catch(() => ({ data: [] }))
  //     .then((personsRes) => {
  //       const personsData = personsRes.data;
  //       setFeaturedPersons(Array.isArray(personsData) ? personsData.slice(0, 3) : (personsData?.content || []).slice(0, 3));
  //     }).finally(() => setLoading(false));
  // }, []);

  // if (loading) {
  //   return <div className={styles.loading}>{t('common.loading')}</div>;
  // }

  return (
    <div className={styles.home}>
      <SlideBannerBlock />

      <section className={styles.searchSection}>
        <div className={styles.container}>
          <h1 className={styles.welcome}>{t('home.welcome')}</h1>
          <p className={styles.subtitle}>{t('home.subtitle')}</p>
          <div className={styles.searchWrapper}>
            <Search />
          </div>
        </div>
      </section>

      {randomBooks.length > 0 && (
        <section className={styles.booksSection}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>{t('home.featuredBooks')}</h2>
              <Link to="/catalog" className={styles.viewAll}>
                {t('home.viewAll')} →
              </Link>
            </div>

            <div className={styles.booksGrid}>
              {randomBooks.map((book) => (
                <Link to={`/book/${book.id}`} key={book.id} className={styles.bookCard}>
                  <div className={styles.bookPoster}>
                    {book.coverUrl ? (
                      <img src={getMediaUrl(book.coverUrl)} alt={book.title} className={styles.bookCover} />
                    ) : (
                      <div className={styles.bookIcon}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                        </svg>
                      </div>
                    )}
                  </div>
                  <h3 className={styles.bookTitle} title={book.title}>{book.title}</h3>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

{/* <section className={styles.personsSection}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>{t('home.featuredPersons')}</h2>
            <Link to="/persons" className={styles.viewAll}>
              {t('home.viewAll')} →
            </Link>
          </div>

          <div className={styles.personsGrid}>
            {featuredPersons.map((person) => (
              <Link to={`/persons/${person.id}`} key={person.id} className={styles.personCard}>
                {person.imageUrl && (
                  <div className={styles.personImage}>
                    <img src={getMediaUrl(person.imageUrl)} alt={person.name} />
                  </div>
                )}
                <h3 className={styles.personName}>{person.name}</h3>
                <p className={styles.personRole}>{person.role}</p>
              </Link>
            ))}
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home;
